const menuPages: { [key: string]: string } = {
  "dashboard": "/dashboard",
  "tags": "/dashboard-configuration/tags",
  "alarms": "/alarms",
  "tickets": "/tickets",
  "data_sources": "/data-sources",
  "users": "/users",
  "logs": "/logs",
  "health": "/health",
  "3DGS": "/3d-dashboard"
};

export default menuPages;